import React, { useState, useEffect } from "react";
import { getEmpresasTodas, eliminarEmpresa, EmpresaListItem } from "../../services/api";
import ConfirmarEliminacion from "../../components/ConfirmarEliminacion";

interface Props {
  usuarioId: number;
  token: string;
  onDatosCambiados?: () => void;
}

export default function EmpresasAdmin({ usuarioId, token, onDatosCambiados }: Props) {
  const [empresas, setEmpresas] = useState<EmpresaListItem[]>([]);
  const [cargando, setCargando] = useState(true);
  const [mensajeError, setMensajeError] = useState("");
  const [mensajeOk, setMensajeOk] = useState("");
  const [aEliminar, setAEliminar] = useState<EmpresaListItem | null>(null);

  const cargar = async () => {
    setCargando(true);
    const data = await getEmpresasTodas(usuarioId, token);
    setEmpresas(data);
    setCargando(false);
  };

  useEffect(() => { cargar(); }, []);

  const mostrarError = (mensaje: string) => {
    setMensajeError(mensaje || "Ocurrió un error");
    setTimeout(() => setMensajeError(""), 4000);
  };

  const handleEliminar = async () => {
    if (!aEliminar) return;
    const res = await eliminarEmpresa(aEliminar.empresaId, usuarioId, token);
    setAEliminar(null);
    if (res.ok) {
      setMensajeOk("Empresa eliminada");
      setTimeout(() => setMensajeOk(""), 2000);
      await cargar();
      onDatosCambiados?.();
    } else {
      mostrarError(res.mensaje);
    }
  };

  return (
    <div style={styles.tarjeta}>
      <div style={styles.header}>
        <span style={styles.titulo}>Empresas</span>
      </div>

      {mensajeOk && <div style={styles.mensajeOk}>✓ {mensajeOk}</div>}
      {mensajeError && <div style={styles.mensajeError}>✕ {mensajeError}</div>}

      {cargando ? (
        <div style={styles.vacio}>Cargando...</div>
      ) : empresas.length === 0 ? (
        <div style={styles.vacio}>No hay empresas cargadas.</div>
      ) : (
        <table style={styles.tabla}>
          <thead>
            <tr>
              <th style={styles.th}>Nombre</th>
              <th style={styles.th}>RUT</th>
              <th style={styles.th}>Grupo</th>
              <th style={styles.th}>Estado</th>
              <th style={styles.th}></th>
            </tr>
          </thead>
          <tbody>
            {empresas.map(e => (
              <tr key={e.empresaId}>
                <td style={styles.td}>{e.nombre}</td>
                <td style={styles.td}>{e.rut || "—"}</td>
                <td style={styles.td}>{e.grupoEmpresaNombre || "—"}</td>
                <td style={styles.td}>
                  <span style={{ ...styles.badge, ...(e.activo ? styles.badgeActivo : styles.badgeInactivo) }}>
                    {e.activo ? "Activa" : "Inactiva"}
                  </span>
                </td>
                <td style={styles.td}>
                  <button style={styles.btnEliminar} onClick={() => setAEliminar(e)}>Eliminar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {aEliminar && (
        <ConfirmarEliminacion
          titulo={`Eliminar empresa "${aEliminar.nombre}"`}
          nombreEsperado={aEliminar.nombre}
          advertencia="Se borra la empresa y sus asignaciones de usuarios/roles. Si tiene plan de cuentas, monedas o cotizaciones cargados, no se va a poder eliminar."
          onConfirmar={handleEliminar}
          onCancelar={() => setAEliminar(null)}
        />
      )}
    </div>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  tarjeta: { backgroundColor: "#fff", borderRadius: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.06)", padding: 24 },
  header: { marginBottom: 16, borderBottom: "1px solid #f0f0f0", paddingBottom: 14 },
  titulo: { fontSize: 17, fontWeight: 700, color: "#1a1a2e" },
  tabla: { width: "100%", borderCollapse: "collapse" as const },
  th: { textAlign: "left" as const, fontSize: 11, fontWeight: 700, color: "#999", textTransform: "uppercase" as const, letterSpacing: "0.5px", padding: "8px 10px", borderBottom: "2px solid #f0f0f0" },
  td: { padding: "10px 10px", fontSize: 13, color: "#333", borderBottom: "1px solid #f5f5f5" },
  badge: { padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600 },
  badgeActivo: { backgroundColor: "#e8f8f0", color: "#27ae60" },
  badgeInactivo: { backgroundColor: "#f4f6f8", color: "#888" },
  btnEliminar: { padding: "5px 12px", backgroundColor: "#fff0f0", color: "#e74c3c", border: "1px solid #f5c6c6", borderRadius: 6, fontSize: 12, cursor: "pointer" },
  vacio: { padding: 20, textAlign: "center" as const, color: "#bbb", fontSize: 13 },
  mensajeOk: { backgroundColor: "#e8f8f0", color: "#27ae60", padding: "10px 16px", borderRadius: 8, fontSize: 13, marginBottom: 12 },
  mensajeError: { backgroundColor: "#fff0f0", color: "#e74c3c", padding: "10px 16px", borderRadius: 8, fontSize: 13, marginBottom: 12 },
};
